import React from 'react';

import slider1 from '@/public/assets/Images/avi/slider1.png';
import slider2 from '@/public/assets/Images/avi/slider2.png';
import slider3 from '@/public/assets/Images/avi/slider3.png';
import slider4 from '@/public/assets/Images/avi/slider4.png';
import slider5 from '@/public/assets/Images/avi/slider5.png';
import slider6 from '@/public/assets/Images/avi/slider6.png';
import slider7 from '@/public/assets/Images/avi/slider7.png';
import slider8 from '@/public/assets/Images/avi/slider8.png';
import whyAviImg1 from '@/public/assets/Images/avi/why-avi-img1.png';
import whyAviImg2 from '@/public/assets/Images/avi/why-avi-img2.png';
import whyAviImg3 from '@/public/assets/Images/avi/why-avi-img3.png';
import whyAviImg4 from '@/public/assets/Images/avi/why-avi-img4.png';

export const GAME_DETAIL_CONFIG = [
  {
    title: 'Avi-Prizestorm-GameType',
    description: 'Avi-Prizestorm-GameType-Second sentance',
  },
  {
    title: 'Avi-PrizeStorm-RTP',
    description: 'Avi-PrizeStorm-RTP-SecondSentance',
  },
  {
    title: 'Avi-PrizeStorm-ReleaseDate',
    description: 'Avi-PrizeStorm-ReleaseDate-SecondSentance',
  },
  {
    title: 'Avi-PrizeStorm-SupportedDevices',
    description: 'Avi-PrizeStorm-SupportedDevices-SecondSentance',
  },
];

export const FAQ_CONFIG = [
  {
    question: 'Avi-FAQ-Question1',
    answer: 'Avi-FAQ-Answer1',
  },
  {
    question: 'Avi-FAQ-Question2',
    answer: 'Avi-FAQ-Answer2',
  },
  {
    question: 'Avi-FAQ-Question3',
    answer: 'Avi-FAQ-Answer3',
  },
  {
    question: 'Avi-FAQ-Question4',
    answer: 'Avi-FAQ-Answer4',
  },
];

export const SLIDER_CONFIG = [
  slider1,
  slider2,
  slider3,
  slider4,
  slider5,
  slider6,
  slider7,
  slider8,
];

// @ts-ignore
function NextArrow(props) {
  const { onClick } = props;
  return (
    <div className="avi-page-gallery-slider-arrow-item" onClick={onClick}>
      <i className="bc-i-arrow-left" />
    </div>
  );
}

// @ts-ignore
function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div className="avi-page-gallery-slider-arrow-item" onClick={onClick}>
      <i className="bc-i-arrow-right" />
    </div>
  );
}

export const AVI_CAROUSEL_SETTINGS = {
  dots: true,
  speed: 300,
  arrows: false,
  infinite: true,
  autoplay: true,
  centerMode: true,
  slidesToScroll: 1,
  autoplaySpeed: 5000,
  nextArrow: <NextArrow />,
  prevArrow: <PrevArrow />,
  customPaging: (i: number) => (
    <div className={'sliderBottomTab'}>
      <span className="sliderBottomTabCircle" />
    </div>
  ),
  appendDots: (dots: React.ReactNode) => (
    <div className="homSliderBottomTabRow">
      <ul>{dots}</ul>
    </div>
  ),
};

export const WHY_AVI_CONFIG = [
  {
    title: 'Avi-Feature-1',
    image: whyAviImg1,
  },
  {
    title: 'Avi-Feature-2',
    image: whyAviImg2,
  },
  {
    title: 'Avi-Feature-3',
    image: whyAviImg3,
  },
  {
    title: 'Avi-Feature-4',
    image: whyAviImg4,
  },
];

export const PRIZE_STORM_CONFIG = [
  {
    icon: 'bc-i-check1',
    title: 'Avi-PrizeStorm-Feature1-TitleAvi-PrizeStorm-Feature1-Title',
    description1: 'Avi-PrizeStorm-Feature1-Desc',
    description2: '',
  },
  {
    icon: 'bc-i-check1',
    title: 'Avi-PrizeStorm-Feature2-Title',
    description1: 'Avi-PrizeStorm-Feature2-Desc',
    description2: '',
  },
  {
    icon: 'bc-i-check1',
    title: 'Avi-PrizeStorm-Feature3-Title',
    description1: 'Avi-PrizeStorm-Feature3-Desc',
    description2: '',
  },
  {
    icon: 'bc-i-flesh',
    title: 'Avi-PrizeStorm-Title-Benefits',
    description1: 'Avi-PrizeStorm-Benefit1',
    description2: 'Avi-PrizeStorm-Benefit2',
  },
];
